import React, { useContext, useReducer, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { CollectionContextProvider } from '../../state/CollectionContext'
import { Story } from '../story/Story'
import { CollectionsQuery } from '../../util/types'

export function CategoryCollection({collectionsData}: {collectionsData: CollectionsQuery | null}) {
  const { slug } = useParams()
  const name = collectionsData?.categories.find(c => c.slug === slug)?.name
  if (!slug || !name) return null


  return (
    <CollectionContextProvider slug={slug} type='category'>
      <Story collectionName={name}/>
    </CollectionContextProvider>
  )
}

export function TopicCollection({ collectionsData }: { collectionsData: CollectionsQuery | null }) {
  const { slug } = useParams()
  const name = collectionsData?.topics.find((c) => c.slug === slug)?.name
  if (!slug || !name) return null

  return (
    <CollectionContextProvider slug={slug} type='topic'>
      <Story collectionName={name} />
    </CollectionContextProvider>
  )
}
